import { Map, fromJS } from 'immutable'
import * as actions from './actions'

export const initialState = Map()

export default function (state = initialState, action) {
  switch (action.type) {
    case actions.SET_PAYMENT_TOKEN_PROCESSING:
      return state.set('processing', action.payload)
    case actions.SET_PAYMENT_TOKEN_ERROR:
      return state.withMutations(mutateState => mutateState
        .setIn(['data', 'error'], action.payload.data)
        .set('processing', action.payload.processing))
    case actions.SET_PAYMENT_TOKEN_DATA:
      return state.withMutations(mutateState => mutateState
        .setIn(['data', 'token'], action.payload.data)
        .set('processing', action.payload.processing))
    case actions.RESET_PAYMENT_TOKEN_DATA:
      return state.delete('data')
    case actions.SET_PAYMENT_IFRAME_INITIALIZED:
      return state.setIn(['data', 'iframe', 'init'], action.payload)
    case actions.SET_PAYMENT_IFRAME_LANGUAGE:
      return state.setIn(['data', 'iframe', 'language'], action.payload)
    case actions.SET_PAYMENT_BILLING_DATA:
      return state.setIn(['data', 'billing'], fromJS(action.payload))
    default:
      return state
  }
}
